import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormulaireService } from '../formulaire.service';

@Component({
  selector: 'app-formulaire-nouveau',
  template: ''
})

export class FormulaireNouveauComponent implements OnInit {

  constructor(private formulaireService: FormulaireService, private router: Router) {}

  ngOnInit() {
    this.formulaireService.reset();
    this.router.navigate(['/formulaire/pret']);
  }

}



// WEBPACK FOOTER //
// ./src/app/formulaire-nouveau/formulaire-nouveau.component.ts